import { getEventTransfer } from 'slate-react'
import Html from 'slate-html-serializer'

const BLOCK_TAGS = {
	blockquote: 'block-quote',
	p: 'paragraph',
	ul: 'bulleted-list',
	ol: 'numbered-list',
	li: 'list-item',
	h1: 'heading-two',
	h2: 'heading-three',

	// Fallback
	h3: 'heading-three',
	h4: 'heading-three',
	h5: 'heading-three',
	h6: 'heading-three',
	h7: 'heading-three',
	h8: 'heading-three',
	hr: 'hr',
	// div: 'paragraph'
}

const MARK_TAGS = {
	pre: 'code',
	em: 'italic',
	i: 'italic',
	strong: 'bold',
	b: 'bold',
	s: 'strikethrough',

	// Fallback
	u: 'bold',
}

// Not implemented yet:
// case 'important':

const rules = [
	{
		deserialize(el, next) {
			const type = BLOCK_TAGS[el.tagName.toLowerCase()]

			if (type) {
				return {
					object: 'block',
					type,
					data: {
						className: el.getAttribute('class'),
					},
					nodes: next(el.childNodes),
				}
			}
		},
	},
	{
		deserialize(el, next) {
			const type = MARK_TAGS[el.tagName.toLowerCase()]

			if (type) {
				return {
					object: 'mark',
					type,
					nodes: next(el.childNodes),
				}
			}
		},
	},
	// {
	// 	// Special case for code blocks, which need to grab the nested childNodes.
	// 	deserialize(el, next) {
	// 		if (el.tagName.toLowerCase() === 'pre') {
	// 			const code = el.childNodes[0]
	// 			const childNodes =	code && code.tagName.toLowerCase() === 'code'
	// 				? code.childNodes
	// 				: el.childNodes

	// 			return {
	// 				object: 'block',
	// 				type: 'code',
	// 				nodes: next(childNodes),
	// 			}
	// 		}
	// 	},
	// },
	{
		// Special case for links
		deserialize(el, next) {
			if (el.tagName.toLowerCase() === 'a') {
				return {
					object: 'inline',
					type: 'link',
					data: {
						href: el.getAttribute('href'),
					},
					nodes: next(el.childNodes),
				}
			}
		},
	},
	{
		// Special case for images, to grab their src.
		deserialize(el, next) {
			if (el.tagName.toLowerCase() === 'img') {
				// console.log(el.getAttribute('src'))

				return {
					object: 'block',
					type: 'image',
					nodes: next(el.childNodes),
					data: {
						src: el.getAttribute('src'),
					},
				}
			}
		},
	},
]

const htmlS = new Html({ rules })

export default function HtmlPaste() {
	return {
		onPaste(event, editor, next) {
			const transfer = getEventTransfer(event)
			const { html } = transfer

			if (
				!(transfer.type === 'files' && transfer.html) &&
				transfer.type !== 'html'
			)
				return next()

			const fragment = htmlS.deserialize(html || '')

			if (!fragment) return

			return editor.insertFragment(fragment.document)
		},
	}
}
